import { SlotsCargando } from '../componentes/Cargando.jsx';
import { Estado } from '../componentes/Estado.jsx';

// Mañana, tarde y noche, para que una grilla de veinte horarios no sea un
// muro de números.
const FRANJAS = [
  { nombre: 'Mañana', desde: 0, hasta: 12 },
  { nombre: 'Tarde', desde: 12, hasta: 18 },
  { nombre: 'Noche', desde: 18, hasta: 24 }
];

function agrupar(slots) {
  return FRANJAS
    .map((franja) => ({
      ...franja,
      slots: slots.filter((slot) => {
        const hora = Number(slot.hora.slice(0, 2));
        return hora >= franja.desde && hora < franja.hasta;
      })
    }))
    .filter((franja) => franja.slots.length > 0);
}

export function PasoHorario({ slots, cargando, error, elegido, onElegir, onReintentar, onOtroDia }) {
  if (cargando) return <SlotsCargando />;

  if (error) {
    return (
      <Estado icono="sinSenal" titulo="No pudimos ver los horarios" accion={onReintentar} etiquetaAccion="Probar de nuevo">
        <p>{error}</p>
      </Estado>
    );
  }

  if (slots.length === 0) {
    return (
      <Estado icono="calendario" titulo="Ese día se llenó" accion={onOtroDia} etiquetaAccion="Elegir otro día">
        <p>No quedan horarios libres. Probá con otro día.</p>
      </Estado>
    );
  }

  return (
    <div>
      {agrupar(slots).map((franja) => (
        <section key={franja.nombre} className="franja">
          <h3 className="franja-titulo">{franja.nombre}</h3>
          <div className="slots" role="group" aria-label={`Horarios de la ${franja.nombre.toLowerCase()}`}>
            {franja.slots.map((slot) => (
              <button
                key={slot.inicio}
                type="button"
                className="slot"
                aria-pressed={elegido?.inicio === slot.inicio}
                aria-label={`Reservar a las ${slot.hora}`}
                onClick={() => onElegir(slot)}
              >
                {slot.hora}
              </button>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
